import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from "recharts";

const mockData = [
  { stage: "Completed", count: 24, percentage: 0.60 },
  { stage: "In Progress", count: 12, percentage: 0.30 },
  { stage: "Scheduled", count: 3, percentage: 0.075 },
  { stage: "On Hold", count: 1, percentage: 0.025 },
];

export function PipelineChart() {
  return (
    <Card className="backdrop-blur-xl bg-white/10 dark:bg-black/10 border-white/20">
      <CardHeader>
        <CardTitle className="text-lg font-semibold">Job Completion Stats</CardTitle>
      </CardHeader>
      <CardContent>
        <ResponsiveContainer width="100%" height={300}>
          <BarChart data={mockData}>
            <defs>
              <linearGradient id="barGradient" x1="0" y1="0" x2="0" y2="1">
                <stop offset="0%" stopColor="hsl(var(--primary))" stopOpacity={1}/>
                <stop offset="100%" stopColor="hsl(var(--primary))" stopOpacity={0.6}/>
              </linearGradient>
            </defs>
            <CartesianGrid strokeDasharray="3 3" stroke="hsl(var(--border))" opacity={0.3} />
            <XAxis 
              dataKey="stage" 
              stroke="hsl(var(--muted-foreground))"
              fontSize={12}
              angle={-45}
              textAnchor="end"
              height={80}
            />
            <YAxis 
              stroke="hsl(var(--muted-foreground))"
              fontSize={12}
            />
            <Tooltip 
              contentStyle={{
                backgroundColor: "hsl(var(--background))",
                border: "1px solid hsl(var(--border))",
                borderRadius: "8px",
              }}
              formatter={(value: number, name: string) => {
                if (name === "count") return [value, "Jobs"];
                if (name === "percentage") return [`${(value * 100).toFixed(1)}%`, "Of Total"];
                return [value, name];
              }}
            />
            <Bar 
              dataKey="count" 
              fill="url(#barGradient)" 
              radius={[8, 8, 0, 0]}
            />
          </BarChart>
        </ResponsiveContainer>
      </CardContent>
    </Card>
  );
}
